import script from "./LiveNow.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveNow.vue?vue&type=script&setup=true&lang=js"

import "./LiveNow.vue?vue&type=style&index=0&id=89d47e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d47e14"]])

export default __exports__